import { render, staticRenderFns } from "./FerryEditTable.vue?vue&type=template&id=9787397a&"
import script from "./FerryEditTable.vue?vue&type=script&lang=js&"
export * from "./FerryEditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports